/** 使用指引运行时的纯逻辑，供浏览器和 Node 行为测试共同复用。 */

function progressId(guideOrKey, version) {
  if (typeof guideOrKey === 'object' && guideOrKey) return `${guideOrKey.key}@${guideOrKey.version}`
  return `${guideOrKey}@${version}`
}

function shouldAutoStart(options) {
  const {guide, initialized, recordsById, sessionSeen} = options
  if (!guide || guide.auto === false || guide.primary === false || !initialized) return false
  const id = progressId(guide)
  return !recordsById[id] && !sessionSeen.has(id)
}

function elementIsVisible(element) {
  if (!element || element.isConnected === false || element.hidden) return false
  if (element.disabled) return false
  if (typeof window !== 'undefined' && window.getComputedStyle) {
    const style = window.getComputedStyle(element)
    if (style.display === 'none' || style.visibility === 'hidden') return false
  }
  if (typeof element.getBoundingClientRect === 'function') {
    const rect = element.getBoundingClientRect()
    // 浏览器元素在可见布局中至少有一个非零方向；测试桩可不提供该方法。
    if (rect && rect.width === 0 && rect.height === 0) return false
  }
  return true
}

function elementsForAnchor(documentRef, anchor) {
  if (!documentRef || !anchor) return []
  const selector = `[data-guide="${String(anchor).replace(/"/g, '\\"')}"]`
  if (typeof documentRef.querySelectorAll === 'function') return [...documentRef.querySelectorAll(selector)]
  if (typeof documentRef.querySelector === 'function') {
    const element = documentRef.querySelector(selector)
    return element ? [element] : []
  }
  return []
}

function firstAvailableTarget(documentRef, targets) {
  for (const target of targets || []) {
    const element = elementsForAnchor(documentRef, target.anchor).find(elementIsVisible)
    if (element) return {target, element}
  }
  return null
}

/** 每一步只使用页面作者写好的标题和说明；缺失目标直接跳过，不生成通用兜底步骤。 */
function collectScenarioSteps(scenario, documentRef) {
  return (scenario && scenario.steps || []).map((step) => {
    const resolved = firstAvailableTarget(documentRef, step.targets)
    if (!resolved) return null
    return {
      element: resolved.element,
      popover: {
        title: resolved.target.title || step.title,
        description: resolved.target.description || step.description,
        side: resolved.target.side || step.side || 'bottom',
        align: resolved.target.align || step.align || 'start',
      },
    }
  }).filter(Boolean)
}

function filterWorkflowNodes(nodes, accessiblePaths) {
  const paths = new Set(accessiblePaths || [])
  return (nodes || []).filter((node) => (node.paths || [node.path]).some((path) => paths.has(path)))
}

function filterAccessibleScenarios(scenarios, accessiblePaths, currentRouteName) {
  const paths = new Set(accessiblePaths || [])
  return (scenarios || []).filter((scenario) => {
    const stablePath = scenario.path.replace(/\/:\w+$/, '')
    return scenario.routeName === currentRouteName || paths.has(scenario.path) || paths.has(stablePath)
  })
}

function canReplayGuide(guide) {
  return Boolean(guide && guide.key && Number.isInteger(guide.version) && guide.version > 0 && guide.steps?.length)
}

module.exports = {
  canReplayGuide,
  collectScenarioSteps,
  elementIsVisible,
  filterAccessibleScenarios,
  filterWorkflowNodes,
  firstAvailableTarget,
  progressId,
  shouldAutoStart,
}
